import React, { forwardRef, Ref } from "react";
import { cn } from "@/shared/utils/shadcn";

export interface BlockProps extends React.HTMLProps<HTMLDivElement> {
  layoutClass?: string;
  ref?: Ref<HTMLDivElement>;
}

interface SectionProps extends React.HTMLProps<HTMLDivElement> {
  visible?: boolean;
  ref?: Ref<HTMLDivElement>;
}

const Flex = forwardRef<HTMLDivElement, BlockProps>(
  ({ children, className, layoutClass, ...props }, ref) => (
    <div className={cn(layoutClass, className)} ref={ref} {...props}>
      {children}
    </div>
  )
);

const Row = forwardRef<HTMLDivElement, BlockProps>((props, ref) => (
  <Flex {...props} layoutClass="flex flex-row" ref={ref} />
));

const Column = forwardRef<HTMLDivElement, BlockProps>((props, ref) => (
  <Flex {...props} layoutClass="flex flex-col" ref={ref} />
));

const Center = forwardRef<HTMLDivElement, BlockProps>((props, ref) => (
  <Flex {...props} layoutClass="flex items-center justify-center" ref={ref} />
));

const Section = forwardRef<HTMLDivElement, SectionProps>(
  ({ visible = true, ...rest }, ref) => {
    if (!visible) return null;

    return (
      <section
        {...rest}
        className={`flex flex-col w-full mb-16 ${rest.className || ""}`}
        ref={ref}
      />
    );
  }
);

export { Row, Column, Center, Section };
